module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/sponsor/design-award-50195c9a96003227914fbfcd6d923c38.svg&quot;;"